import { render } from "./ManageUsersGroup.vue?vue&type=template&id=78094f82"
import script from "./ManageUsersGroup.vue?vue&type=script&lang=js"
export * from "./ManageUsersGroup.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__